export const baseUrl = "https://geesendeavour.com/api/";
